import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { CircularProgressComponent } from './circular-progress.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MaterialModule],
  declarations: [CircularProgressComponent],
  exports: [CircularProgressComponent],
})
export class CircularProgressModule {}
